import React from 'react';
import { Formik, Form } from 'formik';
import styled from 'styled-components';
import Modal from '~/components/modal';
import { Autocomplete } from '~/components/form';
import { formats } from '~/helper';

const Container = styled(Form)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

function SupplierModal({ data, title, isOpen, loading, closeModal, onListSuppliers, handleOnSubmit }) {
 
  return (
    <Formik
      enableReinitialize={true}
      initialValues={data}
      >
      {({ values, isValid, touched, errors, handleReset }) => (
        <Modal
          width="560px"
          height="400px"
          hideClose={true}
          open={isOpen}
          hide={closeModal}
          title={title}
          actions={[
            {
              label: 'Cancelar',
              action: () => { handleReset() ; closeModal() },
              disabled: loading
            },
            {
              label: 'Enviar',
              action: () => { handleOnSubmit(values); handleReset() },
              primary: true,
              disabled: loading || !values.supplier
            }
          ]}
          >
          <Container>
            <Autocomplete
              name='supplier'
              label="Fornecedor"
              required={true}
              minLength={1}
              keyField='id'
              value={values.supplier || {}}
              valueFormat={(row) => `${formats.cnpj(row.identify) || row.identify || ''} - ${row.name}`}
              loadData={onListSuppliers}
              emptyText={'Pesquise um colaborador'}
              tipText={'Digite... '}
              loadingText={'Carregando...'}
              notFoundText={'Não encontrado'}
              />
          </Container>
        </Modal>
      )}
    </Formik>
  );
};

export default SupplierModal;
